import Vue from "vue";

const appConstants = {
	constants(){
		
		if(Vue.prototype.$appmode == "development"){
			return {
				BASE_URL:"http://192.168.86.39:2911"
			};
		}
		else{
			return {
				BASE_URL:"https://allaboutpdfapi.com"
			};
		}
	}
}

export { appConstants };